(() => {
  'use strict';
  if (!['nexool.shop', 'www.nexool.shop'].includes(location.hostname)) return;
  const params = new URLSearchParams(location.search);
  if (params.has('preview_theme_id') || params.has('language_edit') || params.has('_fd') || window.Shopify?.designMode || (window.Shopify?.theme?.role && window.Shopify.theme.role !== 'main')) return;
  const supported = ['en','af','sq','am','ar','hy','az','eu','be','bn','bs','bg','ca','ceb','ny','zh-CN','zh-TW','co','hr','cs','da','nl','eo','et','tl','fi','fr','fy','gl','ka','de','el','ht','ha','he','hi','hmn','hu','is','ig','id','ga','it','ja','jv','kn','kk','km','ko','ku','ky','lo','la','lv','lt','lb','mk','mg','ms','ml','mt','mr','mn','my','ne','no','ps','fa','pl','pt','pa','ro','ru','sm','gd','sr','st','sn','sd','si','sk','sl','so','es','su','sw','sv','tg','ta','te','th','tr','uk','ur','uz','vi','cy','yi','yo','zu'];
  const aliases = { nb: 'no', nn: 'no', iw: 'he', fil: 'tl', jw: 'jv' };
  let language = 'en';
  for (const preference of navigator.languages || [navigator.language]) {
    const tag = String(preference).toLowerCase().replace(/_/g, '-');
    const base = tag.split('-')[0];
    const candidate = base === 'zh' ? (/(tw|hk|mo|hant)/.test(tag) ? 'zh-TW' : 'zh-CN') : aliases[base] || base;
    if (supported.includes(candidate)) { language = candidate; break; }
  }
  if (language === 'en') return;
  const target = new URL(location.href);
  target.hostname = (language === 'he' ? 'iw' : language === 'jv' ? 'jw' : language.toLowerCase()) + '.nexool.shop';
  location.replace(target.href);
})();
